import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../common/CustomLoader';
import * as actions from '../../features/events/redux/actions';
import * as homeActions from '../../features/home/redux/actions';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CardTitleHeader from '../../common/ui/CardTitleHeader';
import { notAllowedWord, reservedValues } from '../../common/formElements/reservedKeywords';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { inUseDescription } from '../../common/utils/validate';

class EventForm extends Component {
  static propTypes = {
    events: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };
  state = {
    inUse: true,
  };
  componentDidMount() {
    const { event } = this.props;
    this.setState({ inUse: event.inUse });
  }
  validationForEvent = () => {
    let validationSchema = {
      eventTitle: Yup.string()
        .required('This field is required')
        .max(100, 'Name can not be more than 100 characters')
        .test('reserved', 'This is reserved word please use another', (value) => {
          const lowercaseValue = value ? value.toLowerCase() : '';
          return !reservedValues.includes(lowercaseValue);
        })
        .test('not-allowed', 'This type of word not allowed.', (value) => {
          const lowercaseValue = value ? value.toLowerCase() : '';
          return !notAllowedWord.includes(lowercaseValue);
        }),
    };
    return Yup.object().shape(validationSchema);
  };

  handleSubmit = async (values) => {
    const { event, projectId, version, actions, history } = this.props;
    const { inUse } = this.state;
    if (Object.keys(event).length > 0) {
      const { _id } = event;
      await actions.updateEvent({
        projectId,
        eventId: _id,
        version,
        data: { ...values, inUse: inUse },
      });
    } else {
      await actions
        .saveNewEvent({ projectId, data: values, version })
        .then((res) => {
          if (res) {
            history.push(`/2.0/events/${version}/v/${projectId}/event/${res.uuid}`);
          }
        })
        .catch((err) => console.log(`err`, err));
    }
    this.props.homeActions.loadEvents({ projectId, version });
  };

  createSchemaForEvent = () => {
    const { event } = this.props;
    return {
      eventTitle: event.eventTitle ? event.eventTitle : '',
      page: event.page ? event.page : '',
      pageComponent: event.pageComponent ? event.pageComponent : '',
      description: event.description,
      inUse: event.inUse,
    };
  };

  pageOptions = () => {
    let options = [];
    let pages = this.props.events.pages;
    if (pages.length > 0) {
      options = options.concat(
        pages.map((page) => {
          return { value: page.uuid, label: page.name };
        }),
      );
    }
    return options;
  };

  buttonText = () => {
    const { event } = this.props;
    if (Object.keys(event).length > 0 && event.uuid) {
      return (
        <span>
          <i className={`wb ${drapcodeIcon('update')}`}></i> Update&nbsp;
          <CustomLoader loading={this.props.showLoader} />
        </span>
      );
    } else {
      return (
        <span>
          <i className={`wb ${drapcodeIcon('create')}`}></i> Create&nbsp;
          <CustomLoader loading={this.props.showLoader} />
        </span>
      );
    }
  };

  handleCancel = () => {
    const { projectId, version, actions, history, isUpdateForm } = this.props;
    isUpdateForm ? actions.toggleEventUpdate() : history.push(`/2.0/events/${version}/v/${projectId}`);
  };
  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked });
  };

  render() {
    const { event } = this.props;
    const { inUse } = this.state;
    return (
      <>
        {event && Object.keys(event).length === 0 ? (
          <CardTitleHeader title="Create New Event" />
        ) : (
          ``
        )}

        <Formik
          enableReinitialize={true}
          initialValues={this.createSchemaForEvent()}
          validationSchema={this.validationForEvent()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form className="form-horizontal">
              <div className="row mx-auto">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Event Name"
                      icon="text"
                      infoIcon={true}
                      isRequired={true}
                      infoDescription={
                        'Enter Event Name of your choice. It should not contain special characters or numbers.'
                      }
                    >
                      <Field
                        type="text"
                        name="eventTitle"
                        className="form-control form-control-sm"
                        placeholder="Event Name"
                        title="Enter Event Name"
                      />
                      <ErrorMessage name="eventTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <div className="form-group mb-4">
                    <FormFieldWithLabel
                      cta={false}
                      label="Description (Optional)"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Explains the purpose or usage of the event.'}
                    >
                      <Field
                        type="text"
                        name="description"
                        className="form-control form-control-sm"
                        placeholder="Description For Event"
                      />
                      <ErrorMessage name="description" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  {event && Object.keys(event).length !== 0 ? (
                    <div className="input-group" title="In Use">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="wb webconnect-toggles"></i>
                          {/* <span className="required">*</span> */}
                        </span>
                      </div>
                      <div className="form-check">
                        <CustomRadio label="In Use" isRadio={false}>
                          <input
                            name="inUse"
                            type="checkbox"
                            className="form-check-input"
                            checked={inUse}
                            onChange={this.handleCheckboxChange}
                          />
                        </CustomRadio>
                      </div>
                      <TooltipInfo
                        title={inUseDescription}
                        headerText={`What's In Use?`}
                        showHeader={true}
                        showArrow={true}
                        append={true}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-md"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                </div>
                <div className="col-md-6 text-right">
                  <button
                    type="submit"
                    className="btn btn-theme-submit btn-md"
                    disabled={isSubmitting}
                  >
                    {this.buttonText()}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.events,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventForm);
